import List from "../layout/List";
import Listitem from "../layout/Listitem";

const BuylistingCustomShipping = () => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="w-[25%]">
        <div className="flex items-center justify-between">
          <List className="mt-2.5 flex flex-col gap-y-5">
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Seller accepts"
            />
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Remaining Time"
            />
          </List>
        </div>
      </div>
      <div className="mt-4 flex w-[75%] flex-col gap-y-2">
        <div className="flex w-full items-center justify-between">
          <div className="flex gap-x-2 ">
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Cash
            </p>
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Eft
            </p>
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Bitcoin
            </p>
          </div>
        </div>
        <div className="flex gap-x-3">
          <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
            1 Day 18:44:05
          </p>
        </div>
      </div>
    </div>
  );
};

export default BuylistingCustomShipping;
